import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=3bc92cda&"
import script from "./table-body.vue?vue&type=script&lang=js&"
export * from "./table-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports